/*  Jquery Dialog Plugin Version 0.1 ALPHA
 *  Copyright 2012, Kenneth Spencer
 *  Dual licensed under the MIT or GPL Version 2 licenses.
 */
/*
* Possible Jquery Events: afteropen, afterclose
*/

(function($)
{
    var dialog = null;
    
    $.fn.dialogClick = function(html, options)
    {
        var dialog = new jqueryDialog(this, html, options);
        dialog.click();

        return dialog.node;
    };

    $.fn.dialogOpen = function(html, options)
    {
        var dialog = new jqueryDialog(this, html, options);
        dialog.open();

        return dialog.node;
    };

    $.fn.hasDialog = function(selector)
    {
        var dialog = $(this).data('_dialog');
       
        if (!dialog) {
            return;    
        }
       
        /* Checik if dialog attached to element matches a selector
        */
        if (selector && !dialog.dialog.is(selector)) {
            return false;
        }
        
        return true;
    };

    $.fn.dialogClose = function()
    {
        return this.each(function()
        {
            var dialog;
            if ((dialog = $(this).data('_dialog'))) {
                dialog.close();
            }
        });
    };

})(jQuery);

   
function jqueryDialog(selector, html, options)
{
    this.node = $(selector).first();
    this.body = null;
    this._html = html;

    this.options = {
        'underlay' : false,
        'position' : 'auto', // auto, center, top-left, bottom-left, right-top
        'stem' : false, // Add stem to dialog
        'close' : false, // add close button to dialog
        'id' : 'jquery-dialog',
        'title' : null,
        'class' : null,
        contextmenu: false,
        'fixed' : null,
        parent: null,
        'css' : null // specify css object
    };
    
    if (options.contextmenu) {
        this.options.id = 'contextmenu';    
    }

    this.created = new Date();
    this.clickTarget = null;

    if (options) {
        $.extend(this.options, options);        
    } 

    var self = this;

    this.dialog = null;
    this.underlay = null;

    var p, $p;

    this.scrollParent = null;
    this.parentNode = null;

    for (p = this.node[0]; p && p.nodeType == 1; p = p.parentNode) {
        $p = $(p);

        if (p === document.body) {
            this.parentNode = $p;
            this.scrollParent = $('html');
            break;
        }

       // if (p.scrollHeight > p.clientHeight) {
        if (this.scrollParent === null && $p.css('overflow-y') == 'scroll' || ($p.css('overflow-y') == 'auto' && p.scrollHeight > p.clientHeight )) {
            this.scrollParent = $p;
            
            if (!this.parentNode) {
                this.parentNode = $p;
            }
            break;
        }
    }

    if (this.options.parent === null) {
        this.options.parent = this.parentNode;
    }

    this.node.afterOpen = function(callback)
    {
        $(self).on('afteropen', function()
        {
            callback.call(self, self.body);
        });
    };

    this.node.afterClose = function(callback)
    {
        $(self).on('afterclose', function()
        {
            callback.call(self);
        });
    };
    
    this.click = function()
    {
        this.node.on('click', function(evt)
        {
            if (self.dialog === null) {
                self.open();
            }

            self.clickTarget = evt.target;
            evt.stopPropagation();
        });
    };

    this.open = function()
    {
       if (this.node.data('_dialog')) {
            this.node.data('_dialog').close();
            return;
        }

        // Delay to prevent dialag from getting closed in same action as opened
        setTimeout(function()
        {
            self._doOpen();
        }, 100);

        return this;
    };

    this._doOpen = function()
    {
        var self = this;
        
        var old, oldDialog;
        if (this.options.id && (old = $("#" + this.options.id)) && old.length && (oldDialog = old.data('_dialog'))) {
            oldDialog.close();
        }

        if (this.options.underlay) {
            this.underlay = $('<div id="' + this.options.id + '-underlay" class="dialog-underlay"></div>');
            this.underlay.appendTo(this.options.parent)
            .fadeIn(200)
            .on('click', function(evt)
            {
                self.close();
                evt.stopPropagation();
            });
        }

        var className = this.options.contextmenu ? 'sb-context-menu' : 'dialog';
        
        if (this.options.class) {
            className += ' ' + this.options.class;
        }

        var html = '<div role="dialog" id="' + this.options.id + '" class="' + className + '">';
        if (this.options.title) {
            html += '<div class="dialog-title">' + this.options.title + '</div>';
        }

        if (this.options.close) {
            html += '<a class="dialog-close">Close</a>';
        }

        if (this.options.title) {
            html += '<div class="dialog-body"></div>';
        }
        html += '</div>';

        if (this.node.prop('nodeName') !== 'BODY') {
            this.node.data('_dialog', this);
            this.node.addClass('is-active');
        }

       // var button = this.node.position();
        
        var parent = $(this.options.parent)[0];
        var node = this.node[0];

        // caluclate the distance to the containing parent
        var button = this.button  = {
            top: 0,
            left: 0,
            
        };

        for (var p = node; p && p !== parent && parent.contains(p) && p.nodeType == 1; p = p.offsetParent) {
            button.top += p.offsetTop;
            button.left += p.offsetLeft;
        }

        if ($(this.options.parent).prop('nodeName') !== "BODY") {
          //  button.top += this.scrollParent.scrollTop();
        }
   
      //  button.left -= parseInt($(document.body).css('margin-left'));
        button.width = this.node.outerWidth();
        button.height = this.node.outerHeight();
        button.right = button.left + button.width;
        button.bottom = button.top + button.height;

    /*
        var bounds = {
            top :   $(window).scrollTop(),
            right : $(window).width() + $(window).scrollLeft(),
            bottom : $(window).height() + $(window).scrollTop(),
            left :  $(window).scrollLeft()
        };
    */

        var bounds = this.bounds = {
            top : this.scrollParent.scrollTop(),
            right : this.scrollParent.width() + this.scrollParent.scrollLeft(),
            bottom : this.scrollParent.height() + this.scrollParent.scrollTop(),
            left :  this.scrollParent.scrollLeft()
        };

        var win = $(html).appendTo(this.options.parent);
        this.dialog = win;

        this.dialog.data('_dialog', this);

        if (this.options.css) {
            this.dialog.css(this.options.css);
        }
        
        if (this.options.fixed) {
            this.dialog.css('position', 'fixed');
        }
        
        if (this.options.title) {
            this.body = $(".dialog-body", this.dialog);
        } else {
            this.body = this.dialog;
        }
 
        if (typeof(this._html) == 'function') {
            this._html.call(this);
        } else {
            this.body.append(this._html);
        }

        win.fadeIn(200);
    
        $(this).trigger('afteropen');

        var dimensions = {
            width : win.outerWidth(),
            height: win.outerHeight()
        };

        this.depth = SbEscape.add(this.dialog, function(index)
        {
            var fadeCall = function()
            {
                $(this).remove();
            };

            self.dialog.fadeOut(200, fadeCall);

            if (self.underlay) {
                self.underlay.fadeOut(200, fadeCall);
            }

            $(self).trigger('afterclose');
        
            self.dialog = null;

            if (self.node.removeData('_dialog')) {
                self.node.removeClass('is-active');
                self.node.removeData('_dialog');
            }

            var length = jqueryDialog._currentWindow.length;
            jqueryDialog._currentWindow.splice(self.index, length - self.index);
        });
    
        this.index = jqueryDialog._currentWindow.push(this) - 1;

        if (this.index >= 1) {
            var last = jqueryDialog._currentWindow[this.index - 1];
            this.dialog.css('z-index', parseInt(last.dialog.css('z-index')) + 2);

            if (this.underlay) {
                this.underlay.css('z-index', parseInt(last.dialog.css('z-index')) + 1);
            }
        } 

        if (this.options.close) {
            var close = $('.dialog-close', this.dialog);
            close.on('click', function(evt)
            {
                self.close();
                evt.stopPropagation();
            });
        }

        if (this.options.position instanceof Function) {
            this.options.position.call(this, bounds, dimensions);
        } else {
            var position = this.toCamel(this.options.position);
            if (this[position]) {
                this[position](button, bounds, dimensions);
            }
        }

        if (this.options.stem) {
            var stem = this.options.stem;
            let args;
            if (typeof(stem) == 'object' && stem.length == 4) {
                args = stem;
            } else {
                args = [10, 10, 10, 20];
            }
            args.unshift(this.getStemPosition());
            
            this.drawStem.apply(this, args);
        }

        /* We don't want to close the window by clicking on it
        */
        win.on('click', function(evt)
        {
            if (evt.button !== 0) {
                return;
            }
          
            var index = SbEscape.closest(evt.target);
            if (index !== false) {
                SbEscape.clear(index + 1);
            }  
    
        });

    /*
        // The above preventDefault stops help from working in windows. 
        // temporary code here until we can sort it out
        win.on("click", ".help, .help-button", function()
        {
            $(this).dialogOpen('<div>' + $(this).data('help') + '</div>', {
                'position' : 'right-top',
                'stem' : true,
                'id' : 'help-dialog'
            });
        });
    */

    };

    this.center = function ()
    {
      //  var marginLeft = 0;//parseInt($(document.body).css('margin-left')) / 2;

        var left = 0 - (this.dialog.outerWidth() / 2) + $(window).scrollLeft();
        var top = 0 - (this.dialog.outerHeight() / 2) + $(window).scrollTop();

        this.dialog.css({
            left:		'50%', 
            top:		'50%',
            marginLeft: left,
            marginTop: top
        });
    };

    this.left = function(button, bounds, win)
    {
        var stemOffset = this.options.stem ? 10 : 0;
        var className;
        var left;
        
        if ((button.left + win.width) <= bounds.right) {
            className = 'left';
            left = button.left - stemOffset;
        } else {
            className = 'right';
            left = button.right - win.width + stemOffset;
     	    if (left < bounds.left) {
                left = bounds.left;
            }
        }

        this.dialog.css('left', left + 'px');
        return className;
    };

    this.auto = function(button, bounds, win)
    {
        this.bottomLeft(button, bounds, win);
    };

    this.rightTop = function(button, bounds, win)
    {
        var stemWidth = this.options.stem ? 10 : 0;
        var stemOffset = this.options.stem ? 10 : 10;

        var top, left;
        var className;
        if ((button.right + win.width + stemWidth) <= bounds.right) {
            className = 'right';
            left = button.right + stemWidth;

        } else {
            className = 'left';
            left = button.left - win.width - stemWidth; 
     	    if (left < bounds.left + stemWidth) {
                left = bounds.right - win.width;
            }
        }

        var down = button.bottom - win.height;
        
        if (button.top + win.height > bounds.bottom && down > bounds.top) {
            className += '-bottom';
            top = down + stemOffset;
        } else {
            className += '-top';
            top = button.top - stemOffset;
        }

        this.dialog.addClass(className);
        this.dialog.css({
            'top' : top + 'px',
            'left' : left + 'px'
        });
    };

    this.bottomLeft = function(button, bounds, win)
    {
        var stemHeight = this.options.stem ? 10 : 0;

        var className;

        var top;
        if (button.bottom + win.height + stemHeight < bounds.bottom) {
            className = 'bottom';
            top = button.bottom + stemHeight;
        } else {
            className = 'top';
            top = button.top - win.height - stemHeight;
            if (top < bounds.top) {
                className = 'bottom';
                top = bounds.top + stemHeight;
            }
        }

        className += "-" + this.left(button, bounds, win);

        this.dialog.addClass(className);
        this.dialog.css('top', top + 'px');
    };

    this.topLeft = function(button, bounds, win)
    {
        var stemHeight = this.options.stem ? 10 : 0;
        var className;

        var up = button.top - win.height;
        var down  = button.bottom;

        var top;
        if (up < bounds.top && down + win.height < bounds.bottom) {
            className = 'bottom-';
            top = down + stemHeight;
        } else {
            className = 'top-';
            top = up - stemHeight;
        }

        className += this.left(button, bounds, win);

        this.dialog.addClass(className);
        this.dialog.css('top', top + 'px');
    };

    this.close = function()
    {
        SbEscape.clear(this.depth);
     //   jqueryDialog.closeFrom(this.depth);
    };
}

/*
jqueryDialog.inOpened = function(node)
{
    for (var i = 0, dialog; (dialog = jqueryDialog._currentWindow[i]); i++) {
        if (node === dialog.dialog[0]) {
            return i;
        }
        
        if (node == dialog.clickTarget) {
            return i;
        }

        if (node == dialog.options.id) {
            return i;
        }

        if ($(node).get(0) === dialog.node.get(0)) {
            return i;
        }
    }

    return -1;
};
*/

jqueryDialog.prototype.toCamel = function(str)
{
    return str.replace(/(-)([a-z])/, function(match, p1, p2)
    {
        return p2.toUpperCase();
    });
};

/* Get the position form the CSS class and invert
*/
jqueryDialog.prototype.getStemPosition = function()
{
    var dialog = this.dialog;
    var pos;

    if (dialog.hasClass('top-left')) {
        pos = 'bottom-left';
    } else if (dialog.hasClass('top-right')) {
        pos = 'bottom-right';
    } else if (dialog.hasClass('right-top')) {
        pos = 'left-top';
    } else if (dialog.hasClass('right-bottom')) {
        pos = 'left-bottom';
    } else if (dialog.hasClass('bottom-left')) {
        pos = 'top-left';
    } else if (dialog.hasClass('bottom-right')) {
        pos = 'top-right';
    } else if (dialog.hasClass('left-top')) {
        pos = 'right-top';
    } else if (dialog.hasClass('left-bottom')) {
        pos = 'right-bottom';
    }

    return pos;
};

jqueryDialog.prototype.drawStem = function(position, offset, length, rise, base)
{
    if (this.stem) {
        this.stem.remove();
    }
    var orientation = position.split('-');

    var canvas = $("<canvas />").appendTo(this.dialog);
    this.stem = canvas;
    this.stem.addClass(this.options['class'] + '-stem');

    if (!canvas[0].getContext) {
        return;
    }

    var width, height;
    if (orientation[0] == 'top' || orientation[0] == 'bottom') {
        width = base;
        height = length;
        canvas.prop('width', base);
        canvas.prop('height', length);
    } else {
        width = length;
        height = base;
    }

    canvas.prop('width', width);
    canvas.prop('height', height);

    var ctx = canvas[0].getContext('2d');

    ctx.fillStyle = this.dialog.css('background-color') || 'white';
   	ctx.strokeStyle = this.dialog.css('border-' + orientation[0] + '-color');

    canvas.css('position', 'absolute');

    switch (orientation[0]) {
    case 'top':
        canvas.css('top',  -length);
  //      this.dialog.css('margin-top', height + parseInt(this.dialog.css('margin-top')));
        break;
    case 'right':
        canvas.css('right',  -length);
  //      this.dialog.css('margin-left', parseInt(this.dialog.css('margin-left') - width));
        break;
    case 'bottom':
        canvas.css('bottom',  -length);
   //     this.dialog.css('margin-top', parseInt(this.dialog.css('margin-top')) - height);
        break;
    case 'left':
        canvas.css('left',  -length);
   //     this.dialog.css('margin-left', width + parseInt(this.dialog.css('margin-left')));
        break;
    }

    switch (orientation[1]) {
    case 'top':
        canvas.css('top',  offset);
        break;
    case 'right':
        canvas.css('right',  offset);
        break;
    case 'bottom':
        canvas.css('bottom',  offset);
        break;
    case 'left':
        canvas.css('left',  offset);
        break;
    }

   	ctx.beginPath();

    switch (position) {
    case 'top-left':
        ctx.moveTo(0, length);
        ctx.lineTo(rise, 0);
        ctx.lineTo(base, length);
        break;
    case 'top-right':
        ctx.moveTo(0, length);
        ctx.lineTo(base - rise, 0);
        ctx.lineTo(base, length);
        break;
    case 'bottom-left':
        ctx.moveTo(0, 0);
        ctx.lineTo(rise, length);
        ctx.lineTo(base, 0);
        break;
    case 'bottom-right':
        ctx.moveTo(0, 0);
        ctx.lineTo(base - rise, length);
        ctx.lineTo(base, 0);
        break;
    case 'left-top':
        ctx.moveTo(length, 0);
        ctx.lineTo(0, rise);
        ctx.lineTo(length, base);
        break;
    case 'left-bottom':
        ctx.moveTo(length, 0);
        ctx.lineTo(0, base - rise);
        ctx.lineTo(length, base);
        break;
    case 'right-top':
        ctx.moveTo(0, 0);
        ctx.lineTo(length, rise);
        ctx.lineTo(0, base);
        break;
    case 'right-bottom':
        ctx.moveTo(0, 0);
        ctx.lineTo(length, base - rise);
        ctx.lineTo(0, base);
        break;
    }

    ctx.fill();
    ctx.stroke();

};


jqueryDialog._currentWindow = []; // Stack of Windows
jqueryDialog.disableEscape = false; // toggle escape key

$(document).ready(function()
{
    /* Close Open Window when escape key is pressed
    */
    $(document).on('keydown', function(evt)
    {
        if (jqueryDialog.disableEscape) {
            return;
        }

        if (jqueryDialog._currentWindow.length === 0) {
            return;
        }

        var dialog;

    /*
        if (evt.which == 27) {
            $(document.activeElement).blur(); // force input to fire change event
            jqueryDialog.closeFrom(jqueryDialog._currentWindow.length - 1);
        }
    */
    });

    /* Close Open Window when clicking outside of window (left mouse button)
    */
    $(document).on('click', function(evt)
    {
    /*
        if (evt.button === 0 && jqueryDialog.inOpened(evt.target) === -1) {
            jqueryDialog.closeFrom(0);
            return;
        }
    */

        if (evt.button === 0 && !SbEscape.contains(evt.target)) {
            SbEscape.clear(0);
            return;
        }
    });
});

